import {Module} from "@/common/module/module";

export default (blockName)=>{
      return [Module.BASE,Module.EDUCATIONAL_BACKGROUND,Module.CAMPUS_ACTIVITIES,Module.INTERNSHIP_EXPERIENCE,Module.WORK_EXPERIENCE,Module.PROJECT_EXPERIENCE,Module.PORTFOLIO].includes(blockName)
}
//判断module-main 是列表
